

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { Pratica } from "src/app/models/pratica.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheService } from "src/app/services/pratiche.service";

  

@Component({
    selector: "component-completa-pratica-fase3",
    templateUrl: "./dialog-completa-pratica.component.html",
    styleUrls: ["../fase3.bando1.component.css"],
  })
  export class CompletaFase3 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected praticaFromFirestore: PraticaFlowdy2_Firestore;
    protected pratica: Pratica;
     completaPraticaForm: FormGroup;

    protected computoMetricoFile: File = null;
    protected isComputoMetricoUploaded: boolean = false;
    
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
    ) {
      this.pratica          = this.config.data.pratica;
      this.logger.info(this.pratica);
      this.completaPraticaForm = this.formBuilder.group({
            ordineEsecuzione: [this.pratica.datiFase3.ordineEsecuzione?this.pratica.datiFase3.ordineEsecuzione:null, [Validators.required]],
            nomePerInvio:     [this.pratica.codiceInvio, [Validators.required]],
      
          });
    }

    ngOnInit(): void {
    }


    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.logger.info("+++ COMPLETA PRATICA +++");
        
        this.logger.info(this.pratica);

        this.pratica.datiFase3.ordineEsecuzione = this.completaPraticaForm.value.ordineEsecuzione;
        this.pratica.codiceInvio      = this.completaPraticaForm.value.nomePerInvio;
        this.praticheService.comunicaOrdineEsecuzione(this.pratica).subscribe(res =>{
      
          this.logger.info("OK SALVATAGGIO ORDINE ESECUZIONE");
            //2) carico i file se sono stati passati
            this.praticheService.completaPratica(this.pratica.id.valueOf()).subscribe(res =>{
              this.dialogRef.close({ success: true });
            });
          });
      } 
    }
  
  }